import { AxiosInstance } from 'axios';
import { Test } from '../../models/test';
import { responseHandler } from './response';
import {Exam, ExamType} from '../../models/exam';

export const getExams = async (client: AxiosInstance) =>
  responseHandler<Exam[]>(client.get('/exams'))

export const getExam = async (client: AxiosInstance, examId: string) =>
  responseHandler<Exam>(client.get(`/exams/${examId}`))

export const getExamResourceImg = async (client: AxiosInstance, examType: ExamType) =>
    responseHandler<string>(client.get(`/exams/${examType}/img`))